import { Theme } from "@mui/material";
import Button from "./Button";
import CssBaseLine from "./CssBaseLine";
import Checkbox from "./Checkbox";
import CardContent from "./CardContent";
import Badge from "./Badge";
import IconButton from "./IconButton";
import InputLabel from "./InputLabel";
import LinearProgress from "./LinearProgress";
import Link from "./Link";
import ListItemIcon from "./ListItemIcon";
import OutlinedInput from "./OutlinedInput";
import Tab from "./Tab";
import TableCell from "./TableCell";
import Tabs from "./Tabs";
import Typography from "./Typography";

const ComponentsOverrides = (theme:Theme) =>{
    return Object.assign( 
        Badge(theme) ,
        Button(theme) ,
        Checkbox(theme) ,
        CardContent() ,
        CssBaseLine() ,
        IconButton(theme) ,
        InputLabel(theme) ,
        LinearProgress() ,
        Link() ,
        ListItemIcon(),
        OutlinedInput(theme),
        Tab(theme),
        TableCell(theme),
        Tabs(),
        Typography()
    );
}

export default ComponentsOverrides;